import styled from "styled-components";

export const ContainerCardPeriodic = styled.div`
  border-radius: 12px;
  padding: 18px 24px;
  margin-bottom: 12px;
  background-color: #ffffff;
  border: 1px solid #e2e8f0;
  box-shadow: 0px 2px 6px rgba(0, 0, 0, 0.03);
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);

  &:hover {
    border-color: #0a5190;
    box-shadow: 0px 6px 14px rgba(10, 81, 144, 0.08);
  }
`;

export const ContainerCalendar = styled.div<{isMobile: boolean, isOutdated: boolean}>`
  border-radius: 4px;
  align-items: center;
  justify-content: center;
  align-self: center;
  display: flex;
  width: ${props=>props.isMobile? "200px":"170px;"};
  height: 40px;
  background-color: ${props=>props.isOutdated? '#991b1b1a':''};
`;

export const DivRowFlex = styled.div`
  display: flex;
  flex-direction: row;
  width: 250px;
`;

export const DivFlexBetween = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;

export const ButtonViewDetalher = styled.div`
  display: flex;
  align-self: center;
  justify-content: center;
  cursor: pointer;
  align-items: center;
`;

export const InnerOccupacionalHealthContainer = styled.div`
  border-radius: 8px;
  padding: 8px 16px;
  margin-bottom: 10px;
  background-color: white;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;
